import {
    Button,
    Container,
    Heading,
    Input,
    Text,
    VStack,
  } from '@chakra-ui/react';
  import React from 'react';
  import { Link } from 'react-router-dom';
  
const Login = () => {
  return (
    <Container h={"100vh"} maxWw={"xl"} p={"8"} >
        <VStack h={"full"} justifyContent={"center"} spacing={"8"} alignItems={"stretch"} >
            <Heading>Welcome Back</Heading>
            <Input type='email' placeholder='Email' focusBorderColor='purple.500' required/>
            <Input type='password' placeholder='Password' focusBorderColor='purple.500' required/>
            <Button variant={"link"} alignSelf={"flex-end"}><Link  to={"/signup"} textalin="right">Forget password ?</Link></Button>
            <Button variant={"solid"} colorScheme='purple'>Log In</Button>
            <Text alignSelf={"flex-end"}>New User ? {"  "}
                <Button colorScheme='purple' variant={"link"}>
                  <Link to={"/signup"}>Sign Up</Link>
                </Button>
            </Text>
        </VStack>

    </Container>
  )
}

export default Login